import styled from 'styled-components';
import React from 'react'
import { VodapayLogoV2 } from 'src/assets/images';

const Image = styled.img`
  position: absolute;
  left: 40px;
  top: 31px;
`;

export const VodaPayLogoV2 = () => {
  return <Image  src={VodapayLogoV2}/>;
}
